module.exports = __webpack_public_path__ + "img/NormalSeat_PeachPink.95b03005.png";